import React from 'react';
import PropTypes from 'prop-types';
import { Field, withFormik } from 'formik';
import {
  CheckboxWrapper,
  StaticFormLayout,
  GridContainer,
  GridItem,
} from '../../common';
import { getFormValue } from '../../../util/helpers';

const AT_DOCTOR = 'atDoctor';
const AT_HOME = 'atHome';
const AT_PHARMACY = 'atPharmacy';

function NotificationSettingsForm(props) {
  return (
    <StaticFormLayout {...props} submitButtonText="Update Notifications">
      <GridContainer spacing={24}>
        <GridItem xs={12}>
          <Field
            component={CheckboxWrapper}
            id={AT_HOME}
            label="When I am at Home"
            name={AT_HOME}
          />
        </GridItem>
        <GridItem xs={12}>
          <Field
            component={CheckboxWrapper}
            id={AT_DOCTOR}
            label="When I am at the Doctor"
            name={AT_DOCTOR}
          />
        </GridItem>
        <GridItem xs={12}>
          <Field
            component={CheckboxWrapper}
            id={AT_PHARMACY}
            label="When I am at the Pharmacy"
            name={AT_PHARMACY}
          />
        </GridItem>
      </GridContainer>
    </StaticFormLayout>
  );
}

NotificationSettingsForm.propTypes = {
  notificationSettings: PropTypes.shape({
    atDoctor: PropTypes.bool,
    atHome: PropTypes.bool,
    atPharmacy: PropTypes.bool,
  }).isRequired,
  onSave: PropTypes.func.isRequired,
};

export default withFormik({
  displayName: 'NotificationSettingsForm',
  enableReinitialize: true,
  handleSubmit: (values, { props, setStatus, setSubmitting }) => {
    const { atDoctor, atHome, atPharmacy } = values;
    return props
      .onSave({ atDoctor, atHome, atPharmacy })
      .then(() => {
        setStatus({ hasSaved: true, saveError: null });
      })
      .catch(error => {
        setStatus({ saveError: error });
      })
      .finally(() => {
        setSubmitting(false);
      });
  },
  mapPropsToValues: ({ notificationSettings }) => {
    const atDoctor = getFormValue(notificationSettings, AT_DOCTOR, false);
    const atHome = getFormValue(notificationSettings, AT_HOME, false);
    const atPharmacy = getFormValue(notificationSettings, AT_PHARMACY, false);

    return {
      atDoctor,
      atHome,
      atPharmacy,
    };
  },
})(NotificationSettingsForm);



// WEBPACK FOOTER //
// ./src/modules/SettingsPage/components/NotificationSettingsForm.js